import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dropdown-redirect"
export default class extends Controller {
  static values = {
    redirectImmediately: { type: Boolean, default: true }
  }

  connect() {
    this.element.addEventListener("change", this.redirect.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("change", this.redirect.bind(this))
  }

  redirect(event) {
    const selectedOption = event.target.options[event.target.selectedIndex]
    const url = selectedOption.dataset.url

    if (url) {
      if (this.redirectImmediatelyValue) {
        window.location.href = url
      } else {
        // Useful if you want to delay the redirect or add animations
        this.dispatch("redirect", { detail: { url } })
      }
    }
  }
}
